(ns portal.advertiser-configuration-page.view.whitelist
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.panel :refer [panel]]
            [portal.advertiser-configuration-page.db.whitelist :as form]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal confirm-delete :whitelist/confirm-delete
  [{:keys [id url]}]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:form.whitelist/delete-whitelist-url id])
    :entity-name "allowlist domain"
    :confirmation-message (str "Are you sure you want to delete '"
                               url "' from the allowlist?")}])

(defui whitelist-clause
  [{:keys [id url]}]
  ($ Box
     {:sx #js {:display "grid"
               :gap 1
               :gridTemplateColumns "30rem max-content"
               :alignItems "center"}}
     ($ :span url)
     ($ IconButton
        {:onClick #(rf/dispatch [:modal/open {:id :whitelist/confirm-delete
                                              :props {:id id
                                                      :url url}}])}
        ($ Icon "delete"))))

(defui whitelist-form
  []
  (let [urls-by-id (use-subscribe [:form.whitelist/whitelist-urls])]
    ($ Box
       {:component "form"
        :sx #js {:my 4}
        :on-submit (fn [e]
                     (.preventDefault e)
                     (rf/dispatch [:form.whitelist/submit]))}
       ($ panel {:title "Allowlist domains for Click URLs"
                 :data-testid :advertiser-config-panel--whitelist-urls}
          (if (seq urls-by-id)
            (for [[id url] urls-by-id]
              ($ whitelist-clause {:key id :id id :url url}))
            ($ :span {:data-testid :advertiser-whitelist-form--empty-label}
               "Currently all Click URLs are allowed"))
          ($ form-field
             {:label "Add a domain to the allowlist"
              :err-msg (form/use-error-message [:whitelist-url])
              :data-testid "whitelist"
              :sx #js {:mt 2}}
             ($ Box
                {:sx #js {:display "grid"
                          :gridTemplateColumns "30rem 10rem"
                          :gap 1}}
                ($ input
                   (merge (form/use-bind-control [:whitelist-url])
                          {:type "text"
                           :placeholder "example.com"
                           :data-testid "whitelistUrlInput"}))
                ($ Button
                   {:type "submit"
                    :startIcon ($ Icon "add")
                    :data-testid "whitelistUrlAddButton"}
                   "Add")))))))
